<mat-toolbar class="header">
  <a [routerLink]="path()" class="header__logo">
    <img src="/assets/images/analytics.svg">
  </a>
  <div class="header__options">
    <coa-select-client class="header__select-client"></coa-select-client>

    <button [mat-menu-trigger-for]="menu" class="menu__trigger" mat-mini-fab>
      {{(token$ | async)?.user_name | uppercase | slice : 0 : 1}}
    </button>

    <mat-menu
      #menu="matMenu"
      [xPosition]="'before'"
      class="header__user-menu menu__body">
      <button
        class="menu__login"
        disabled
        mat-menu-item>
        <span>{{(token$ | async)?.user_name}}</span>
      </button>
      <button
        *ngIf="(token$ | async)?.authorities?.includes('cmp:campaign:support') && (token$ | async)?.authorities?.includes('cmp:campaign:sps-support')"
        [routerLink]="['/manage-clients']"
        class="menu__manage-clients"
        mat-menu-item>
        <mat-icon class="menu__logout-icon">supervisor_account</mat-icon>
        <span>{{'Manage clients' | translate}}</span>
      </button>
      <button
        [routerLink]="['/select-client']"
        class="menu__select-client"
        mat-menu-item>
        <mat-icon class="menu__logout-icon">person_search</mat-icon>
        <span>{{'Choose a client' | translate}}</span>
      </button>
      <button
        (click)="logout()"
        class="menu__logout"
        mat-menu-item>
        <mat-icon class="menu__logout-icon">exit_to_app</mat-icon>
        <span>{{ 'Logout' | translate }}</span>
      </button>
    </mat-menu>
  </div>
</mat-toolbar>
